// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"336":"8e5f37d4","410":"4df8e0fb","510":"a3fffd59","549":"4e2da5b4","936":"6adf7770"}[chunkId] + ".chunk.js";
};